const getBasedUrl = (url, baseUrl) => `${baseUrl.replace(/\/+$/, "")}${url}`;
export {
  getBasedUrl
};
//# sourceMappingURL=get-based-url.js.map
